// extracted by mini-css-extract-plugin
export default {"tarjeta":"Tarjeta_tarjeta__4++I-","portada":"Tarjeta_portada__NIFSF"};